import React, { useEffect, useRef, useState } from "react";
import styles from "./SlidingGallery.module.css";

// --- IMPORT ALL 13 IMAGES (With Correct Extensions) ---
import img1 from "../../assets/sliding-images/1.jpeg";
import img2 from "../../assets/sliding-images/2.jpeg";
import img3 from "../../assets/sliding-images/3.jpg";
import img4 from "../../assets/sliding-images/4.jpeg";
import img5 from "../../assets/sliding-images/5.jpeg";
import img6 from "../../assets/sliding-images/6.jpeg";
import img7 from "../../assets/sliding-images/7.jpeg";
import img8 from "../../assets/sliding-images/8.jpg";
import img9 from "../../assets/sliding-images/9.jpg";
import img10 from "../../assets/sliding-images/10.jpg";
import img11 from "../../assets/sliding-images/11.jpg";
import img12 from "../../assets/sliding-images/12.jpg";
import img13 from "../../assets/sliding-images/13.jpg";

// --- ORGANIZED ROWS (Aesthetic Grouping) ---

// Row 1: The "Classy Coffee" Experience (Hot drinks & Pour overs)
const row1Images = [
  img1, // Espresso
  img4, // Latte Art
  img6, // Pour Over
  img10, // Matcha Latte
];

// Row 2: The "Delicious Food" Menu (Burgers, Pastries, Snacks)
const row2Images = [
  img3, // Burger
  img13, // Waffles
  img8, // Samosas
  img11, // Pancakes
];

// Row 3: "Refreshing & Specialty" (Iced drinks + Meat Dish)
const row3Images = [
  img5, // Iced Coffee Lime
  img7, // Green Iced Drink
  img9, // Iced Latte
  img2, // Matcha Cup
  img12, // Meat Dish
];

function SlidingGallery() {
  const [scrollY, setScrollY] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        // Only update scroll state when section is near viewport
        if (rect.top < window.innerHeight + 200 && rect.bottom > -200) {
          setScrollY(window.scrollY);
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className={styles.gallerySection} ref={sectionRef}>
      <div className={styles.headerContent}>
        {/* --- UPDATED TITLE & SUBTITLE --- */}
        <h2>Sip, Savor & Satisfy</h2>
        <p>
          From premium Ethiopian coffee to gourmet meals, discover your perfect
          pairing.
        </p>
      </div>

      {/* ROW 1: Moves Left */}
      <div
        className={styles.row}
        style={{ transform: `translateX(${50 - scrollY * 0.1}px)` }}
      >
        {row1Images.map((src, index) => (
          <div key={`r1-${index}`} className={styles.card}>
            <img src={src} alt="Dukamo Coffee Experience" />
            <div className={styles.cardShadow}></div>
          </div>
        ))}
      </div>

      {/* ROW 2: Moves Right */}
      <div
        className={styles.row}
        style={{ transform: `translateX(${-400 + scrollY * 0.08}px)` }}
      >
        {row2Images.map((src, index) => (
          <div key={`r2-${index}`} className={styles.card}>
            <img src={src} alt="Dukamo Food Menu" />
            <div className={styles.cardShadow}></div>
          </div>
        ))}
      </div>

      {/* ROW 3: Moves Left */}
      <div
        className={styles.row}
        style={{ transform: `translateX(${0 - scrollY * 0.12}px)` }}
      >
        {row3Images.map((src, index) => (
          <div key={`r3-${index}`} className={styles.card}>
            <img src={src} alt="Dukamo Specialty Items" />
            <div className={styles.cardShadow}></div>
          </div>
        ))}
      </div>

      {/* Vignettes for Fade Effect */}
      <div className={styles.fadeOverlayLeft}></div>
      <div className={styles.fadeOverlayRight}></div>
      <div className={styles.fadeOverlayTop}></div>
      <div className={styles.fadeOverlayBottom}></div>
    </section>
  );
}

export default SlidingGallery;
